import React, { Component } from 'react'
import {
  RenderConfiguredVehicle
} from 'containers'
import { ColorSelector, Tabs, InteriorSelector } from 'components'
import { H2, H6, Space, H4 } from 'AtomicComponents'

class BuildColorStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display360Status: false
    }
  }
  mutateColorOptions = options =>
    options.map((option) => {
      const newOption = Object.assign({}, option)
      newOption.label = newOption.priceDifference
        ? `${option.name} | $${Number(option.priceDifference).toLocaleString('nz')}`
        : option.name
      return newOption
    })

  changeDisplay360Status = (newValue) => {
    this.setState({
      display360Status: newValue
    })
  }

  _renderColors = () => {
    const radio = this.props.stepData.radioGroup[this.props.selectColorInterior ? 1 : 0]
    const props = {
      onChange: this.props.handleChangeOption,
      options: this.mutateColorOptions(this.props.options[radio.groupName]),
      active: this.props.options[radio.groupName].indexOf(this.props.options[radio.itemName]),
      only: this.props.options[radio.groupName].length <= 1
    }
    return (
      <div>
        <Tabs
          divider
          options={[{ name: 'exterior' }, { name: 'interior' }]}
          active={this.props.selectColorInterior ? 1 : 0}
          onChange={(option, index) => {
            this.props.handleChangeInterior(index)
          }} />
          { this.props.selectColorInterior ?
            <InteriorSelector padding="0 0 1em 0" {...props} />
          :
            <ColorSelector padding="0 0 1em 0" {...props} />
          }
      </div>
    )
  }

  _renderCompact = () => {
    const newSelectIndex = this.props.stepData.colorSelector
      && (this.props.selectColorInterior ? 1 : 0)
    const activeOption = this.props.options[this.props.stepData.radioGroup[newSelectIndex].itemName]
    return (
      <div style={{ minHeight: '20vh', padding: '1em' }}>
        <div>
          {activeOption.name && <H4 withDetails>{activeOption.name}</H4>}
          {this._renderColors()}
        </div>
        <div>
          <RenderConfiguredVehicle
            display360={this.props.display360}
            display360Status={this.state.display360Status}
            step={this.props.stepData}
            isSelectColorInterior={Boolean(this.props.selectColorInterior)}
            options={this.props.options}
            changeDisplay360Status={this.changeDisplay360Status}
            onChange={this.props.handleChangeOption}
            compact={this.props.compact}
            selectIndex={newSelectIndex}
            showDescription
            background={!this.props.stepData.fullWidth} />
        </div>
      </div>
    )
  }

  _render = () => (
    <div>
      <div style={stepStyles.stepHeader}>
        <H6 withDetails>
          {this.props.mainHeading}
        </H6>
        <H2
          withDetails
          align={'center'}
        >
          {this.props.stepData.heading}
        </H2>
        <Space />
        {this._renderColors()}
      </div>
      <div style={{ padding: '0em 15vw' }}>
        <RenderConfiguredVehicle
          display360={this.props.display360}
          display360Status={this.state.display360Status}
          step={this.props.stepData}
          isSelectColorInterior={Boolean(this.props.selectColorInterior)}
          options={this.props.options}
          changeDisplay360Status={this.changeDisplay360Status}
          onChange={this.props.handleChangeOption}
          compact={this.props.compact}
          selectIndex={
            this.props.stepData.colorSelector && (this.props.selectColorInterior ? 1 : 0)
          }
          showDescription
          background={!this.props.stepData.fullWidth} />
      </div>
    </div>
  )
  render() {
    return this.props.compact ? this._renderCompact() : this._render()
  }
}
export default BuildColorStep

const stepStyles = {
  divider: {
    height: '2em',
    width: '1px',
    margin: '0px 1.8em 0 1.7em',
    background: '#cbcbcb',
    transform: 'rotate(30deg)',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  stepHeader: {
    paddingTop: '30px',
    minHeight: '20vh'
  }
}



// WEBPACK FOOTER //
// ./src/containers/build/build-color-step.jsx